// extracted by mini-css-extract-plugin
export const seo_review_card = "SeoReviewCard-module--seo_review_card--8OzeK";
export const form_grid = "SeoReviewCard-module--form_grid--5w3fg";
export const with_label = "SeoReviewCard-module--with_label--3p0GN";
export const contact_title = "SeoReviewCard-module--contact_title--sYjDq";
export const bouncy = "SeoReviewCard-module--bouncy--3FnYD";
export const pop = "SeoReviewCard-module--pop--2Wlwb";